import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { BandOption } from "../../../../models/ran-configuration/band-option";

@Component({
    selector: 'oaibox-band-create-configuration',
    templateUrl: './band-create-configuration.component.html',
    styleUrls: ['./band-create-configuration.component.css'],
    imports: [ReactiveFormsModule]
})
export class BandCreateConfigurationComponent {

  @Input() public defaultBandOptions?: BandOption[];
  @Input() public editableBandOptions?: BandOption[];
  @Output() public optionsChange: EventEmitter<BandOption[]> = new EventEmitter();

  public bandOptionsForm: FormGroup;

  constructor() {
    this.bandOptionsForm = new FormGroup({
      band: new FormControl(undefined, Validators.required),
      ssbArfcn: new FormControl(undefined, Validators.required),
      dlPointAArfcn: new FormControl(undefined, Validators.required),
      ulPointAArfcn: new FormControl(undefined, Validators.required),
    });
  }

  public addBandOption() {
    let bandOption: BandOption = {
      band: this.bandOptionsForm.value.band,
      ssbArfcn: this.bandOptionsForm.value.ssbArfcn,
      dlPointAArfcn: this.bandOptionsForm.value.dlPointAArfcn,
      ulPointAArfcn: this.bandOptionsForm.value.ulPointAArfcn,
    };
    if(!this.editableBandOptions) this.editableBandOptions = [];
    this.editableBandOptions.push(bandOption);
    this.optionsChange.emit(this.editableBandOptions);
    this.bandOptionsForm.reset();
  }

  public removeBandOption(index: number) {
    this.editableBandOptions?.splice(index, 1);
    this.optionsChange.emit(this.editableBandOptions);
  }
}
